import { types, Instance } from 'mobx-state-tree';
const { number, model } = types;

export const EndUserNotificationModel = model('EndUserNotificationModel', {
  count: number,
});

export type IEndUserNotificationModel = Instance<typeof EndUserNotificationModel>;
